<template>
	<div>
		<template v-if="typeans == 'preview' || typeans == 'archivePreview'">
			<div v-for="(item, index) in questionData" :key="item['questionKey']">
				<div v-if="item['questionKey'].slice(0, 4) == 'MAFO'">
					<Mafo :data="item" :showindex="index + 1" />
				</div>

				<div v-if="item['questionKey'].slice(0, 4) == 'MCQU'">
					<McqCard :data="item" :showindex="index + 1" />
				</div>
				<div v-if="item['questionKey'].slice(0, 4) == 'LONG'">
					<LongCard :data="item" :showindex="index + 1" />
				</div>
				<div v-if="item['questionKey'].slice(0, 4) == 'CODE'">
					<CodeCard :data="item" :showindex="index + 1" />
				</div>
				<div v-if="item['questionKey'].slice(0, 4) == 'COMU'">
					<CommunicationCard :data="item" :showindex="index + 1" />
				</div>
				<hr v-if="index != questionData.length - 1" />
			</div>
		</template>
		<template v-if="typeans == 'autopreview'">
			<div v-for="(item, index) in autoquestionData" :key="item['questionKey']">
				<div v-if="item['questionKey'].slice(0, 4) == 'MAFO'">
					<Mafo :data="item" :showindex="index + 1" />
				</div>

				<div v-if="item['questionKey'].slice(0, 4) == 'MCQU'">
					<McqCard :data="item" :showindex="index + 1" />
				</div>
				<div v-if="item['questionKey'].slice(0, 4) == 'LONG'">
					<LongCard :data="item" :showindex="index + 1" />
				</div>
				<div v-if="item['questionKey'].slice(0, 4) == 'CODE'">
					<CodeCard :data="item" :showindex="index + 1" />
				</div>
				<hr v-if="index != autoquestionData.length - 1" />
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Mafo from "../components/testpreviewCards/mafo";
import McqCard from "../components/testpreviewCards/mcqAnswer";
import LongCard from "../components/testpreviewCards/long.vue";
import CodeCard from "../components/testpreviewCards/code.vue";
import CommunicationCard from "@/components/testpreviewCards/CommunicationCard.vue";
export default {
	name: "AnswerCards",
	props: {
		typeans: String,
	},
	components: {
		LongCard,
		Mafo,
		McqCard,
		CodeCard,
		CommunicationCard,
	},

	computed: {
		...mapGetters("questionVUEX", {
			questionData: "getQuestionData",
		}),
		...mapGetters("autotestVUEX", {
			autoquestionData: "getQuestionData",
		}),
	},
	mounted() {
		console.table("autoquestionData", this.autoquestionData);
	},
};
</script>
